import script from "./SimRadioButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./SimRadioButtons.vue?vue&type=script&setup=true&lang=js"

import "./SimRadioButtons.vue?vue&type=style&index=0&id=d511e752&lang=scss"

const __exports__ = script;

export default __exports__